import {
    Card,
    Col,
    Row,
    Image,
    Button,
    Media,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState }from "react";
import axios from 'axios';
import { LinkContainer } from 'react-router-bootstrap'


export default function DentistCard(props) {
    const dentist = props.dentist;
    const dhaUniqueId = props.dentist.dhaUniqueId;
    let history = useHistory();
    const backup_picture_url ="https://upload.wikimedia.org/wikipedia/commons/thumb/archive/a/ac/20121003093557%21No_image_available.svg/120px-No_image_available.svg.png"
    let [image, setImage] = useState(backup_picture_url)



     useEffect( () => {
        axios.post("https://uae-dentist-backend.herokuapp.com/staff/get-image", {dhaUniqueId})
        .then(result => {
            if(result.data.length > 10){
                setImage('data:image/jpeg;base64,'+ result.data);
            }
        })
      }, [dhaUniqueId]);

    const watchDentist = (dentist) => {
        history.push({
            pathname: `/dentists/${dentist.full_name.toLowerCase()}/`,
            state: { dentist },
        });
    };
    
        return (
            <div>
                <Card className="card my-2">
                    <Card.Body>
                    <Media>
                        {image && 
                            <LinkContainer style={{cursor: 'pointer'}} to={{
                                pathname: `/dentists/${dentist.full_name && dentist.full_name.toLowerCase()}/`,
                                state: { dentist },
                            }}>
                                <Image
                                className="mr-3"
                                thumbnail
                                src={image}
                                alt="Card image cap"
                                style={{"maxWidth": "120px", "maxHeight": "120px"}}
                                />
                            </LinkContainer>
                        }
                        <Media.Body>
                        <Row>
                            <Col sm={12} md={7} lg={8}>
                            <LinkContainer style={{cursor: 'pointer'}} to={{
                                pathname: `/dentists/${dentist.full_name && dentist.full_name.toLowerCase()}/`,
                                state: { dentist },
                            }}>
                            <h5>{dentist.full_name}</h5>
                            {/* <p className="text-muted">{dentist.email}</p> */}
                            </LinkContainer>
                            </Col>
                            <Col>
                            <Button
                                className="float-right"
                                variant="info"
                                onClick={() => watchDentist(dentist)}
                            >
                                Watch Dentist
                            </Button>
                            </Col>
                        </Row>
                        <p>{dentist.biography}</p>
                        </Media.Body>
                    </Media>
                </Card.Body>
            </Card>
          </div>
        );
      }
    